import { Injectable } from "@angular/core";
import { HttpClient, HttpEvent, HttpParams } from '@angular/common/http';
import { tap, mergeMap } from "rxjs";
import { OrganisationConversationTemplate } from "../models/organisation/organisation-conversation-template";
import { OrganisationConversationTemplatePatch } from "../models/organisation/organisation-conversation-template-patch";
import { OrganisationConversationTemplatePost } from "../models/organisation/organisation-conversation-template-post";
import { ConversationTemplateTypeCategory } from "../models/organisation/organisation-conversation-template-type";
import { AccountService } from "./account.service";
import { ConfigService } from "./config.service";
import { FileService } from "./file.service";
import { ManageOrganisationService } from "./manage-organisation.service";
import { ConversationTemplateType } from "../models/organisation/conversation-template-type";
import { ConversationTemplateTypePatch } from "../models/organisation/conversation-template-patch";

@Injectable()
export class ConversationTemplatesService {

    constructor(
        private http: HttpClient,
        private configService: ConfigService,
        private manageOrganisationService: ManageOrganisationService,
        private fileService: FileService,
        private accountService: AccountService) {
    }

    addConversationTemplate(model: OrganisationConversationTemplatePost) {
        const organisationReference = this.manageOrganisationService.getOrganisationReference();
        const url = `${this.configService.baseUrl}/manage/organisation/${organisationReference}/conversation-templates`

        return this.fileService.uploadFiles(model.files)
            .pipe(tap(_ => model.files = this.fileService.prepareFilePosts(model.files)),
                mergeMap(_ => this.http.post<OrganisationConversationTemplate>(url, model)));
    }

    patchConversationTemplate(guid: string, model: OrganisationConversationTemplatePatch) {
        const organisationReference = this.manageOrganisationService.getOrganisationReference();
        const url = `${this.configService.baseUrl}/manage/organisation/${organisationReference}/conversation-templates/${guid}`

        return this.fileService.uploadFiles(model.files)
            .pipe(tap(_ => model.files = this.fileService.prepareFilePosts(model.files)),
                mergeMap(_ => this.http.patch<OrganisationConversationTemplate>(url, model)));
    }

    removeConversationTemplate(guid: string) {
        const organisationReference = this.manageOrganisationService.getOrganisationReference();
        const url = `${this.configService.baseUrl}/manage/organisation/${organisationReference}/conversation-templates/${guid}`
        return this.http.delete<void>(url);
    }

    getTypeTemplates(typeCategory: ConversationTemplateTypeCategory) {
        const organisationReference = this.manageOrganisationService.getOrganisationReference();
        const url = `${this.configService.baseUrl}/manage/organisation/${organisationReference}/conversation-template-types/${typeCategory}/templates`
        return this.http.get<OrganisationConversationTemplate[]>(url);
    }

    getTemplateType(typeCategory: ConversationTemplateTypeCategory) {
        const organisationReference = this.manageOrganisationService.getOrganisationReference();
        const url = `${this.configService.baseUrl}/manage/organisation/${organisationReference}/conversation-template-types/${typeCategory}`
        return this.http.get<ConversationTemplateType>(url);
    }

    patchTemplateType(typeCategory: ConversationTemplateTypeCategory, model: ConversationTemplateTypePatch) {
        const organisationReference = this.manageOrganisationService.getOrganisationReference();
        const url = `${this.configService.baseUrl}/manage/organisation/${organisationReference}/conversation-template-types/${typeCategory}`
        return this.http.patch<ConversationTemplateType>(url, model);

    }
}